function Loading() {
  return (
    <div
      className="flex justify-center items-center flex-1"
      role="status"
      aria-live="polite"
      aria-label="Carregando"
      aria-busy="true"
    >
      <div
        className="animate-spin rounded-full h-18 w-18 border-b-4 border-primary-600"
        aria-hidden="true"
      />
    </div>
  );
}

export default Loading;


